import React from "react";
import { Button } from "primereact/button";
import { Image } from "primereact/image";
import { useNavigate } from "react-router-dom";

type PageLinkType = {
    forward: string | null,
    backward: string | null,
}

type DemoImageProps = {
    src: string,
    alt: string,
    dataTestId: string,
    pageLinks: PageLinkType
}

export const DemoImage = ({ src, alt, dataTestId, pageLinks }: DemoImageProps) => {
    const navigate = useNavigate()
    return (
        <div className="bg-purple-800">
            <Image
                className="flex justify-content-center relative h-screen m-0 page-fade-in"
                key={src}
                src={src}
                alt={alt}
                data-cy={dataTestId}
            />
            <div className="flex justify-content-center absolute bottom-0 w-screen mb-4">
                <Button
                    className="mx-2 w-5rem"
                    style={{backgroundImage: 'linear-gradient(180deg, #50C4CA 0%, #2BAAE2 100%)'}}
                    icon="pi pi-chevron-left"
                    rounded
                    outlined
                    severity="info"
                    onClick={() => navigate(pageLinks?.backward)}
                    pt={{icon: {className: 'mx-3', style: {color: '#000'}}}}
                />
                <Button
                    className="mx-2 w-5rem"
                    style={{backgroundImage: 'linear-gradient(180deg, #50C4CA 0%, #2BAAE2 100%)'}}
                    icon="pi pi-chevron-right"
                    pt={{icon: {style: {color: '#000'}}}}
                    rounded
                    outlined
                    severity="info"
                    onClick={() => navigate(pageLinks?.forward)}
                />
            </div>
        </div>
    )
}
